import type { Parameters } from '../../../../../types/typeHelper';

export enum ConnectionsQueryKeys {
  GET_ERP_CUSTOMER_USERS = 'GET_ERP_CUSTOMER_USERS',
  UPDATE_ERP_CUSTOMER_USER = 'UPDATE_ERP_CUSTOMER_USER',
}

export const getGetErpCustomerUsersQueryKey = (
  path: Parameters<'/admin/connections/{connection_id}/connection-members', 'get'>['path'],
) => [ConnectionsQueryKeys.GET_ERP_CUSTOMER_USERS, path];
